module.exports = __webpack_public_path__ + "static/img/error-image@2x.0233cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error-image@2x.png
// module id = 107
// module chunks = 1